import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { photos } from '../data/site';
import { timeline } from '../data/content';
import { PageIntro } from '../components/ui/PageIntro';
import { CtaBand } from '../components/ui/CtaBand';
const today = ['Docent muziek en economie in het voortgezet onderwijs', 'Piano- en gitaardocent', 'Zanger en dirigent van koren, waaronder Dijksound', 'Gitarist en zanger in een coverband', 'Singer-songwriter, met o.a. een eigen kerstsingle'];
const inspirations = ['Queen', 'The Eagles', 'Dire Straits', 'Procol Harum', 'Stef Bos', 'Peter Slager (BLØF)'];
export function About() {
  usePageTitle('Over mij');
  return <>
      <PageIntro eyebrow="Over mij" title={<>
            Een muzikaal verhaal, <em className="text-amber" data-id="element-266" data-mp="1guy4f7lj8ixl">sinds mijn zevende.</em>
          </>} intro="Ik ben Bas Menninga, geboren in 1998 in Blaricum en woonachtig in Huizen. Singer-songwriter, muziekdocent en — als het aan mij ligt — straks ook op úw feest." image={{
      src: photos.riverside,
      alt: 'Bas leunt op een reling langs de rivier bij avondlicht',
      position: '50% 55%'
    }} data-id="element-265" data-mp="2x97ss1pry7of" />

      <section aria-label="Mijn verhaal" className="w-full bg-paper text-ink" data-id="element-267" data-mp="1pl1owfx5zxqg">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-32" data-id="element-268" data-mp="23jroq3bdcbii">
          <div className="space-y-6 text-[18px] leading-[1.7] text-ink/80 lg:col-span-7" data-id="element-269" data-mp="1ylhoheasekq1">
            <p className="font-serif text-4xl leading-[1.15] text-ink md:text-5xl" data-id="element-270" data-mp="2dejjz0hhama4">
              Het begon met de VHS-banden van Queen in Wembley en <em data-id="element-271" data-mp="2m8ptdv4azrrj">Hell Freezes Over</em> van The Eagles.
            </p>
            <p data-id="element-272" data-mp="2mask6hda5oxb">
              Als klein ventje was ik al geboeid door alles wat met muziek te maken had. Mijn ouders keken veel naar concerten van Procol
              Harum en Dire Straits, en die gitaristen op het podium hadden iets magisch voor mij. Na lang smeken kreeg ik op mijn
              zevende mijn eerste gitaar. Even schrikken: wat die gitaristen deden, ging niet vanzelf.
            </p>
            <p data-id="element-273" data-mp="1ostjggjs14en">
              Jarenlang volgde ik klassieke les, later vrije les waarin ook het schrijven van muziek aan bod kwam. Omdat ik als
              singer-songwriter verder wilde, kwamen daar zang- en pianoles bij.
            </p>
            <figure className="py-4" data-id="element-274" data-mp="22mb5c7zxqt7u">
              <img src={photos.guitarSmile} alt="Bas lachend met zijn gitaar op de heide" className="aspect-[16/10] w-full rounded-sm object-cover" data-id="element-275" data-mp="22nch6eorzjqm" />
            </figure>
            <p data-id="element-276" data-mp="2cj5w24pyvpbk">
              Na de havo koos ik eerst voor zekerheid: een hbo-opleiding Bedrijfskunde. Maar de muziek bleef trekken. In 2023 rondde ik
              mijn docentenopleiding aan het Conservatorium van Amsterdam af.
            </p>
            <p data-id="element-277" data-mp="2lija7ap1d22m">
              Op het podium vind ik het belangrijk om letterlijk de juiste snaar te raken: spelen waar op dat moment behoefte aan is.
              Mijn droom? Ooit een avondvullend programma in een theater als Het Theater in Blaricum — en een eigen nummer dat een
              breed publiek raakt.
            </p>
            <p className="font-serif text-3xl italic text-amber-deep" data-id="element-278" data-mp="ew4ysp50u63r">Hopelijk zien wij elkaar bij iets muzikaals! — Bas</p>
          </div>

          <aside className="space-y-14 lg:col-span-4 lg:col-start-9" data-id="element-279" data-mp="9xtlg4fipdgs">
            <div data-id="element-280" data-mp="4zicdvx1r6zm">
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink/55" data-id="element-281" data-mp="501txbisbtd4">Tijdlijn</h2>
              <ol className="relative mt-6 border-l border-ink/20" data-id="element-282" data-mp="12lpija9017e3">
                {timeline.map(m => <li key={m.year} className="relative pb-8 pl-7 last:pb-0" data-id="element-283" data-mp="xnxreig6hpay">
                    <span aria-hidden className="absolute -left-[5px] top-2.5 h-[9px] w-[9px] rounded-full bg-amber-deep" data-id="element-284" data-mp="smqjmje1cq4a" />
                    <p className="font-serif text-3xl" data-id="element-285" data-mp="ooj0jhw3ncpx">{m.year}</p>
                    <p className="mt-1 text-[15px] leading-relaxed text-ink/70" data-id="element-286" data-mp="3df21ciqoq38v">{m.text}</p>
                  </li>)}
              </ol>
            </div>
            <div data-id="element-287" data-mp="1148vsqrmbxik">
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink/55" data-id="element-288" data-mp="113pixogtrzbe">Vandaag</h2>
              <ul className="mt-4 divide-y divide-ink/15 border-y border-ink/15" data-id="element-289" data-mp="15vqz3lh46a6p">
                {today.map(t => <li key={t} className="py-3 text-[15px] text-ink/80" data-id="element-290" data-mp="r7e2qne46pbo">{t}</li>)}
              </ul>
            </div>
            <div data-id="element-291" data-mp="w2jpfofcc80t">
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink/55" data-id="element-292" data-mp="1juqfk5uh3irs">Inspiratie</h2>
              <p className="mt-4 font-serif text-2xl leading-snug" data-id="element-293" data-mp="1ou39tbnobs4e">{inspirations.join(' · ')}</p>
            </div>
          </aside>
        </div>
      </section>

      <CtaBand title="Kennismaken?" text="Voor een optreden, les of workshop: ik hoor graag waar u aan denkt." to="/contact" label="Neem contact op" data-id="element-294" data-mp="1avv9quvccap0" />
    </>;
}